import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { ArrowDownIcon } from "@heroicons/react/24/solid";
import {
  Card,
  CardHeader,
  Input,
  Chip,
  Typography,
  Button,
  CardBody,
} from "@material-tailwind/react";
import { getSinglePeople } from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import moment from "moment";
import PeopleTrainingPdfView from "../../components/views/PeopleTrainingPdfView";

const TABLE_HEAD = [
  "Training Name",
  "Status",
  "Assigned Date",
  "Last Date",
  "Completion Date",
];

export default function ViewTrainings() {
  const { refreshToken } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [id, setId] = useState("");
  const { id: peopleId } = useParams();
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState("");

  useEffect(() => {
    getSinglePeople(refreshToken, peopleId).then((data) => {
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTemplateData(data?.data?.assignedTraining);
      setIsLoading(false);
    });
  }, [pdfView]);

  const handleSelect = (item) => {
    setPdfView(true);
    setPdfData(item);
    setId(peopleId);
  };

  const exportToExcel = () => {};

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Trainings Assigned
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all trainings assigned to you
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              {!pdfView ? (
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={exportToExcel}
                  loading={isLoading === null ? true : false}
                >
                  <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
                </Button>
              ) : null}
              {!pdfView && (
                <div className="w-full md:w-auto">
                  <Input
                    label="Search"
                    value={searchBy}
                    className="focus:!border-black focus:!border-2 focus:!border-t-0"
                    onChange={(e) => setSearchBy(e.target.value)}
                    icon={<MagnifyingGlassIcon className="h-5 w-5" />}
                  />
                </div>
              )}
            </div>
          </div>
        </CardHeader>
        {pdfView ? (
          <>
            <PeopleTrainingPdfView
              setPdfView={setPdfView}
              pdfData={pdfData}
              peopleId={id}
            />
          </>
        ) : (
          <CardBody className="overflow-scroll px-3 p-0">
            <table className="mt-4 w-full min-w-max table-auto text-left">
              <thead>
                <tr>
                  {TABLE_HEAD.map((head, index) => (
                    <th
                      key={head}
                      className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50"
                    >
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                      >
                        {head}{" "}
                        {index !== TABLE_HEAD.length - 1 && (
                          <ChevronUpDownIcon
                            strokeWidth={2}
                            className="h-4 w-4"
                          />
                        )}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              {isLoading === null ? (
                <>
                  <tbody>
                    <tr>
                      <td colSpan={TABLE_HEAD.length}>
                        <TableSkeleton />
                      </td>
                    </tr>
                  </tbody>
                </>
              ) : (
                <>
                  <tbody>
                    {isLoading === false && templateData?.length > 0 ? (
                      templateData.map((item, index) => {
                        if (!item) return null;
                        const { trainingTitle, trainingLastDate } =
                          item?.training;
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-4"
                          : "p-4 border-b border-blue-gray-50";

                        return (
                          <tr key={`${item?._id}-${index}`}>
                            <td className={classes}>
                              <button
                                type="button"
                                className="flex items-center gap-3 underline"
                                onClick={() => {
                                  handleSelect(item);
                                }}
                              >
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-left capitalize"
                                >
                                  {trainingTitle}
                                </Typography>
                              </button>
                            </td>
                            <td className={classes}>
                              <div className="w-max">
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={item?.status}
                                  color={
                                    item?.status === "completed"
                                      ? "green"
                                      : "yellow"
                                  }
                                />
                              </div>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    item?.assignedDate
                                      ? moment(item?.assignedDate).format(
                                          "MMMM DD, YYYY"
                                        )
                                      : ""
                                  }
                                  className="rounded-full w-fit text-xs	normal-case font-medium	"
                                />
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    trainingLastDate
                                      ? moment(trainingLastDate).format(
                                          "MMMM DD, YYYY"
                                        )
                                      : ""
                                  }
                                  className="rounded-full w-fit text-xs	normal-case font-medium	"
                                />
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    item?.completionDate !== undefined
                                      ? moment(item?.completionDate).format(
                                          "DD-MMMM-YYYY"
                                        )
                                      : ""
                                  }
                                  className="rounded-full w-fit text-xs	normal-case font-medium	"
                                />
                              </Typography>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <div className="flex flex-col items-center w-full">
                            <img
                              quality={100}
                              src="/assets/images/9276430.jpg"
                              className="w-[350px] mix-blend-darken"
                              alt="no-data-found"
                            />
                            <p className="text-[20px] font-medium">
                              No Training Found!
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </>
              )}
            </table>
          </CardBody>
        )}
      </Card>
    </div>
  );
}
